// API 오류 메시지 파서
// FastAPI 응답의 detail 은 세 형태로 옵니다.
//   - 일반 오류: 문자열   { "detail": "이미 존재하는 시리즈입니다: Anytime Korean" }
//   - 422 검증: 배열     { "detail": [{ "loc": ["body","series_volume"], "msg": "..." }] }
//   - 객체      : 무료/사은품 등록 라우트의 구버전 { "detail": { "message": "ISBN을 1개 이상 입력해주세요." } }
// 그냥 String(detail) 하면 422 에서 [object Object] 가 노출되므로 반드시 이 파서를 거칩니다.

// 서버가 돌려주는 필드명을 화면 용어로 바꿔서 보여주기 위한 표
const FIELD_LABELS = {
  name: '시리즈 이름',
  description: '설명',
  sort_order: '노출 순서',
  series_idx: '시리즈',
  series_volume: '권차',
  code: '코드',
  names: '표시명',
  grade: '학습단계',
  field_ids: '도서분야',
  language_ids: '대상언어',
  re_group: '그룹',
  re_level: '깊이',
  re_num: '순서',
  section_key: '섹션 키',
  titles: '섹션 타이틀',
  display_type: '노출 방식',
  display_limit: '노출 개수',
  barcodes: '도서',
}

/**
 * 응답 body 의 detail 을 사람이 읽을 수 있는 한 줄로 만듭니다.
 * @param {string|Array|undefined} detail 응답 body 의 detail
 * @param {string} fallback detail 을 해석하지 못했을 때 쓸 문구
 * @returns {string}
 */
export const parseApiError = (detail, fallback = '요청을 처리하지 못했습니다.') => {
  if (typeof detail === 'string' && detail) return detail

  if (Array.isArray(detail) && detail.length) {
    const e = detail[0]
    const key = Array.isArray(e.loc) ? e.loc[e.loc.length - 1] : ''
    const label = FIELD_LABELS[key] || key
    return label ? `${label}: ${e.msg}` : e.msg || fallback
  }

  // 무료/사은품 등록(POST /payment/admin/insertFreePayment)이 detail 을 객체로 돌려주던 형태입니다.
  // 백엔드가 문자열로 통일하기로 했지만 그 배포 전까지 운영은 여전히 객체를 내려주므로,
  // 두 형태를 모두 흡수해야 배포 전후가 다 안전합니다(백엔드 요청으로 유지).
  // 이 분기가 없으면 fallback 으로 떨어져 실제 사유가 사라지고,
  // String(detail) 을 쓰던 호출부에서는 [object Object] 가 그대로 노출됩니다.
  if (detail && typeof detail === 'object' && typeof detail.message === 'string' && detail.message) {
    return detail.message
  }

  return fallback
}

/**
 * axios 에러 객체에서 곧바로 메시지를 뽑습니다.
 * @param {Error} error axios 가 throw 한 에러
 * @param {string} fallback
 * @returns {string}
 */
export const apiErrorMessage = (error, fallback) =>
  parseApiError(error?.response?.data?.detail, fallback)

/**
 * 응답 상태코드를 꺼냅니다. 네트워크 오류면 undefined.
 * @param {Error} error
 * @returns {number|undefined}
 */
export const apiErrorStatus = (error) => error?.response?.status
